import { render, staticRenderFns } from "./OrgAuthList.vue?vue&type=template&id=0ecc5382"
import script from "./OrgAuthList.vue?vue&type=script&lang=ts"
export * from "./OrgAuthList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports